// Provide the options in global scope so other scripts can call smooth-scroll
// with the same configuration.
window.smoothScrollOptions = {
  ignore: '[data-scroll-ignore],[data-magellan] a',
  topOnEmptyHash: false,
  speed: 250,
  durationMax: 350,
  updateURL: true,
  popstate: true,
  easing: 'easeOutQuad', // See https://github.com/cferdinandi/smooth-scroll/issues/49
  offset(anchor) {
    const stickyEls = document.querySelectorAll('[data-is-sticky-header]');

    // Add an offset so text isn't butted right up against the sticky headers.
    let offset = 20;

    // Remove the offset if we're linking to a page section as these have their
    // own padding and we want the background colour to end exactly under the
    // header and not with a offset gap.
    if (
      anchor.classList.contains('page-section') ||
      anchor.classList.contains('hero-header--below')
    ) {
      offset = 0;
    }

    stickyEls.forEach(function getTotalStickyHeights(el) {
      offset += el.getBoundingClientRect().height;
    });

    return offset;
  },
};

let _stickyHeadersAnchorFix;
let _stickyHeadersAnchorFixBackToTop;

Drupal.behaviors.rutherfordStickyHeadersAnchorFix = {
  attach() {
    // SmoothScroll will destroy any existing initialisations and reinit itself
    // when behaviours are called. I don't think there's a way to pass Drupal's
    // `context` to it, so this seems like the only way of having it apply itself
    // to content that Drupal may have AJAXed in.
    _stickyHeadersAnchorFix = new SmoothScroll(
      'a[href*="#"]:not([href="#main-content"])',
      window.smoothScrollOptions,
    );

    // For 'back to top' links (ones that point to '#main-content' then we don't
    // update the URL.
    _stickyHeadersAnchorFixBackToTop = new SmoothScroll(
      'a[href="#main-content"]',
      _.merge({}, window.smoothScrollOptions, {
        updateURL: false,
        popstate: false,
      }),
    );
  },
};
